import type { Component, Ref } from 'vue'
import { createEntityDeps } from '@st/use/composables'
import type { IconName } from '@st/ui/components/StIcon/types'

interface Tournament {
  id: number
  name: string
  description: string
  bannerUrl: string | null
  previewBannerUrl: string | null
  currencyId: number
  createdAt: string
  lastCalculatedAt: string | null
  status: 'new' | 'visible' | 'open' | 'calculating' | 'canceled' | 'processed'
  type: 'all' | 'bookmaker' | 'cyber' | 'casino'
  validDateFrom: string
  validDateTo: string
  membersNumber: number
  prizePlaceNumber: number
  totalPrizePoolAmount: string
  prizePoolType: 'fixed' | 'dynamic'
  prizeTopList: {
    prizePlace: number
    userNickname: string | null
    userDropAmount: string | null
    prizeAmount: string | null
  }[]
}

interface UserAccount {
  name: string
  code: string
  fiatBalance: string | number
  icon: IconName
  id: number
  currencyId: number
  type: 'real' | 'bonus' | 'freebet'
  balance: string
  allowedForDeposit: boolean
  allowedForWithdrawal: boolean
  bonusAccountAmount: string
}

export interface Currency {
  id: number
  name: string
  code: string
  type?: string
  icon: IconName
}

export interface CasinoDeps {
  isAuthenticated: Ref<boolean>
  isReady: Ref<boolean>
  userCurrencySettings: Ref<{
    defaultCurrencyIdForCasinoGame?: number
    preferredCurrencyCodeForCasino?: string
  }>
  isCurrencyForTMA: (currencyId: number) => boolean
  updateUserPreferredCurrencyCodeForCasino: (
    currencyCode: string,
  ) => Promise<void>
  MAccountWidget: Component
  activeAccount: Ref<UserAccount | undefined>
  appCurrency: Ref<{ code: string; id: number }>
  isAllAccountsEmpty: Ref<boolean>
  casinoTournament: Ref<Tournament | null>
  PageTournamentCard: Component
  MPageTournamentCard: Component
  getCurrencyIdByCode: (code?: string) => number | undefined
  getCurrencyIconById: (id: number) => string | undefined
  getFiatCurrencyCodeById: (id?: number) => string
  getCurrencyById: (id: number) => Currency
  useIntercomApi: any
}

const [useCasinoDeps, provideCasinoDeps] =
  createEntityDeps<CasinoDeps>('casino')

export { useCasinoDeps, provideCasinoDeps }
